import { MathLib, ORACLE_PRICE_SCALE } from '@morpho-org/blue-sdk'

interface GetBorrowPositionLiquidationPriceParams {
  collateral: bigint | null | undefined
  borrowAssets: bigint | null | undefined
  lltv: bigint | null | undefined
}

export const getBorrowPositionLiquidationPrice = ({
  collateral,
  borrowAssets,
  lltv
}: GetBorrowPositionLiquidationPriceParams) => {
  if (!collateral || !borrowAssets || !lltv) return null

  const maxBorrowCollateral = MathLib.wMulDown(collateral, lltv)
  if (maxBorrowCollateral === 0n) return null

  return MathLib.mulDivUp(borrowAssets, ORACLE_PRICE_SCALE, maxBorrowCollateral)
}
